import React from 'react';
import HeaderV3 from '../../components/HeaderV3/headerV3.component';
import FooterSection from '../../components/FooterSection/footersection.component';
import { Fragment } from 'react';

function TermsOfServices() {
  return (
    <Fragment>
      <main className="page-wrapper dark-mode">
        {/* Hero  */}
        <HeaderV3 />
        
        {/* Terms of Service 1 */}
        <section className="position-relative overflow-hidden mt-5  ">
          <div className="container">
            <div className="row flex-lg-nowrap ">
              <div className="col-lg-6 col-xl-6">
                <h1 className="display-6 pt-5 pb-2 pb-lg-3 mt-2 mt-lg-5">TERMS AND CONDITIONS </h1>
                <strong className="d-block mb-3 text-muted">Last updated December 18, 2023 - V.1</strong>
              </div>
            </div>
          </div>
         
        </section>

        {/* Terms of Service 1 PDF */}
        <section className="container mb-5 pt-4 pb-2 py-mg-4">
          <div style={{ width: '100%', height: '1000px' }}>
            <iframe
              title="PDF Viewer 1"
              src={process.env.PUBLIC_URL + "/assets/pdf/LEGAL T&C + SUBSCRIPTION ORDER.pdf"}
              width="100%"
              height="1000px"
            ></iframe>
          </div>
        </section>
        {/* Terms of Service 2 (as a link) */}
        {/* <section className="container mb-5 pt-4 pb-2 py-mg-4">
          <p>Terms of Service V.2  <a target='_blank' href={process.env.PUBLIC_URL + "/assets/pdf/540cb75550adf33f281f29132dddd14fded85bfc.pdf"}><strong>Last updated January 22, 2024</strong></a>
          </p>
        </section> */}

      <FooterSection />
      </main>
    </Fragment>
  );
}

export default TermsOfServices;
